import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Assessment, AssessmentValue } from '../models';

export const assessmentActions = createActionGroup({
    source: 'Assessment',
    events: {
        'Get Assessment': props<{ courseId: string }>(),
        'Get Assessment Success': props<{ payload: Assessment | null }>(),
        'Get Assessment Error': props<{ code: number }>(),
        'Save Assessment': props<{ courseId: string; value: AssessmentValue }>(),
        'Save Assessment Success': props<{ payload: Assessment }>(),
        'Save Assessment Error': props<{ code: number }>(),
        'Patch Assessment': props<{ id: string; value: AssessmentValue }>(),
        'Patch Assessment Success': props<{ payload: Assessment }>(),
        'Patch Assessment Error': props<{ code: number }>(),
        'Delete Assessment': props<{ id: string }>(),
        'Delete Assessment Success': props<{ id: string }>(),
        'Delete Assessment Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
